import React, { useEffect, useState, memo } from 'react';
// Helper functions defined outside the component to avoid hoisting issues
const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
// Memoize the component to prevent unnecessary re-renders
export const CountdownBadge = memo(function CountdownBadge() {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    // Initialize state from cookie if available (only once at component mount)
    if (typeof document !== 'undefined') {
      const storedCount = getCookie('copiesLeft');
      return storedCount ? parseInt(storedCount) : 50;
    }
    return 50;
  });
  useEffect(() => {
    // Set initial cookie if needed
    if (!getCookie('copiesLeft')) {
      setCookie('copiesLeft', '50', 30);
    }
    // Defer the interval setup to not block initial page load
    let intervalId: number;
    const timeoutId = setTimeout(() => {
      // Set up interval to decrease count every 5 seconds
      intervalId = window.setInterval(() => {
        setCopiesLeft(prevCount => {
          // Don't go below 3
          const newCount = prevCount > 3 ? prevCount - 1 : 3;
          // Update cookie with new count
          setCookie('copiesLeft', newCount.toString(), 30);
          return newCount;
        });
      }, 5000);
    }, 2000); // Delay start by 2 seconds
    // Clean up interval on component unmount
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className="inline-flex items-center bg-red-100 text-red-800 px-3 py-1 rounded-full text- font-medium" data-id="element-134">
      Only {copiesLeft} copies left
    </div>;
});